import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rem } from 'polished';
import { Field } from 'redux-form';

import Icon from '../../../components/Icon';
import renderInput from '../../../components/Input/redux-form';

import { formatPrice, __ } from '../../../utilities';
import { ticketTypesByValue } from '../../ConnectionForm';

import Loader from '../../../components/Loader';

import {
  LeftCell,
  RightCell,
  Subtitle,
  Price,
  CountSelect,
  Label,
} from './Row';

const TicketType = styled.div`
  font-size: ${rem(14)};
  text-align: center;
`;

const RowWrapper = styled.label`
  display: flex;
  border-bottom: ${rem(1)} solid #eee;
  flex-direction: column;
  padding: ${rem(10)} ${rem(30)};
  padding-left: ${rem(15)};
  cursor: pointer;
  background: #fff;

  ${({ theme }) => theme.media.sm`
    flex-direction: row;
  `};
  &:last-child {
    border-bottom: 0;
  }
  &:hover {
    background: #f0f0f0;
  }
`;

const Wrapper = styled.div`
  background: #fff;
  border: ${rem(1)} solid ${({ theme }) => theme.color.separator};
  border-radius: 0 ${rem(3)} ${rem(3)} ${rem(3)};
`;

const LabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${rem(10)};
  border-bottom: ${rem(1)} solid #eee;
`;

const SIcon = styled(Icon)`
  display: flex;
`;

const TicketWay = styled.div`
  display: flex;
  flex-direction: row;
  margin: ${rem(10)} 0;
  ${SIcon} {
    margin: 0 ${rem(10)};
  }
`;

const From = styled.div`
  margin-right: ${rem(5)};
`;

const To = styled.div`
  margin-left: ${rem(5)};
`;

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${rem(40)};
`;

class TarrifPicker extends Component {
  constructor(props) {
    super(props);
    this.renderTarrifRow = this.renderTarrifRow.bind(this);
  }

  renderTarrifRow(tarrif, index) {
    const {
      id_tarrif: tarrifId,
      name,
      description,
      price_total: priceTotal,
    } = tarrif;
    return (
      <RowWrapper key={index.toString()}>
        <LeftCell>
          <CountSelect>
            <Field
              name={this.props.input.name}
              type="radio"
              component={renderInput}
              value={tarrifId}
            />
          </CountSelect>
          <div>
            <Label>{name}</Label>
            <Subtitle>{description}</Subtitle>
          </div>
        </LeftCell>
        <RightCell>
          <Price>{formatPrice(priceTotal)}</Price>
        </RightCell>
      </RowWrapper>
    );
  }

  render() {
    const { tarrifs, isFetching, ticket } = this.props;
    if (isFetching) {
      return (
        <LoaderWrapper>
          <Loader size="xxl" />
        </LoaderWrapper>
      );
    }
    return (
      <Wrapper>
        <LabelWrapper>
          <TicketType>
            {__(ticketTypesByValue[ticket.tt])} {__('lístok')}
          </TicketType>
          <TicketWay>
            <From>{ticket.way1_from}</From>
            <SIcon name="arrow-with-bullet" />
            <To>{ticket.way1_to}</To>
          </TicketWay>
        </LabelWrapper>
        {tarrifs.map(this.renderTarrifRow)}
      </Wrapper>
    );
  }
}

TarrifPicker.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  ticket: PropTypes.shape({}).isRequired,
  tarrifs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      description: PropTypes.string,
      price_total: PropTypes.number.isRequired,
      id_tarrif: PropTypes.string.isRequired,
    }).isRequired,
  ),
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
};

TarrifPicker.defaultProps = {
  tarrifs: [],
};

export default TarrifPicker;



// WEBPACK FOOTER //
// ./src/containers/Passengers/TarrifPicker/index.js